import axios from 'axios';
import Cookies from 'js-cookie';
import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL, //'http://127.0.0.1:8000/api',
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = Cookies.get('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
